import api from '../index'

export interface CommunityPostItem {
  id: number
  user_id: number
  category_id: number | null
  topic_id?: number | null
  topic_ids?: number[]
  topic_list?: string[]
  tag_ids?: number[]
  tag_list?: string[]
  content: string | null
  images?: string[]
  videos?: string[]
  image_attachment_ids?: number[]
  video_attachment_ids?: number[]
  image_count?: number
  video_count?: number
  media_count?: number
  cover_image?: string
  cover_video?: string
  visibility: number
  status: number
  audit_status: number
  audit_remark: string | null
  audit_at: string | null
  like_count: number
  comment_count: number
  share_count: number
  browse_count: number
  is_recommended: number
  created_at: string | null
  updated_at: string | null
}

export interface CommunityPostPagePayload {
  list: CommunityPostItem[]
  total: number
  page: number
  per_page: number
}

export interface CommunityPostFormPayload {
  user_id?: number | null
  category_id?: number | null
  topic_id?: number | null
  tag_ids?: number[]
  content?: string | null
  visibility?: number
  status?: number
  audit_status?: number
  audit_remark?: string | null
  image_attachment_ids?: number[]
  video_attachment_ids?: number[]
  like_count?: number
  comment_count?: number
  share_count?: number
  browse_count?: number
  is_recommended?: number
}

export function communityPostPage(params: Record<string, unknown>) {
  return api.get<unknown, { code: number, message: string, data: CommunityPostPagePayload }>('/admin/content/community/post/list', {
    params,
  })
}

export function communityPostDetail(id: number) {
  return api.get<unknown, { code: number, message: string, data: CommunityPostItem }>(`/admin/content/community/post/${id}`)
}

export function communityPostCreate(data: CommunityPostFormPayload) {
  return api.post('/admin/content/community/post', data)
}

export function communityPostUpdate(id: number, data: CommunityPostFormPayload) {
  return api.put(`/admin/content/community/post/${id}`, data)
}

export function communityPostDelete(id: number) {
  return api.delete(`/admin/content/community/post/${id}`)
}

export function communityPostBatchDelete(ids: number[]) {
  return api.delete('/admin/content/community/post/batch', {
    data: { ids },
  })
}

const apiCommunityPost = {
  page: communityPostPage,
  detail: communityPostDetail,
  create: communityPostCreate,
  update: communityPostUpdate,
  delete: communityPostDelete,
  batchDelete: communityPostBatchDelete,
}

export default apiCommunityPost
